import styles from './Block.module.scss';
import cn from 'classnames';
export const Block = ({ children, className, ...props }) => {
  return (
    <div className={cn(styles.block, className)} {...props}>
      {children}
    </div>
  )
}
